import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '@/store/redux';

const SLICE_NAME_LOGIN = 'login';

export enum REDIRECT_FROM {
  'CHECKOUT' = 'checkout',
  'TRADE_IN' = 'trade-in',
  'DEFAULT' = 'account',
}
export interface LoginSliceProps {
  redirectedFrom: REDIRECT_FROM;
}

export const initialState: LoginSliceProps = {
  redirectedFrom: REDIRECT_FROM.DEFAULT,
};

const slice = createSlice({
  name: SLICE_NAME_LOGIN,
  initialState,
  reducers: {
    setUserWasRedirectedFrom(state, action: PayloadAction<REDIRECT_FROM>) {
      state.redirectedFrom = action.payload;
    },

    resetRedirectedFrom() {
      return initialState;
    },
  },
});

export const { setUserWasRedirectedFrom, resetRedirectedFrom } = slice.actions;

export const getLoginState = (state: RootState): LoginSliceProps =>
  state.pages.login;

export default slice.reducer;
